const module = { name: 'mobile/sidebar', exports: {} }; const exports = module.exports;



import { Fandango as Fandango_account_logInUrls } from 'require-core';

const { account: { hasSubscription }, logInUrls: { joinNow, signIn } } = Fandango_account_logInUrls;


const Selectors = {
    APP_DOWNLOAD_ANDROID: '.js-android-app-download',
    APP_DOWNLOAD_IOS: '.js-ios-app-download',
    CLOSE_BTN: '.js-sidebar-nav-close',
    HAMBURGER_MENU: '.js-hamburger-menu',
    JOIN_BTN: '.js-join-btn',
    SIDEBAR_EXPAND_ICON: '.js-sidebar-expand-icon',
    SIDEBAR_NAV: '.js-sidebar-nav',
    SIDEBAR_NAV_CHILD_LINK: '.js-sidebar-nav__child-link',
    SIDEBAR_NAV_CONTENT_WRAPPER: '.sidebar-nav__content-wrapper',
    SIDEBAR_NAV_LINK: '.js-sidebar-nav__link',
    SIDEBAR_NAV_MY_ACCOUNT: 'js-sidebar-nav__my-account',
    SIDEBAR_NAV_MY_ORDERS: 'js-sidebar-nav__my-orders',
    SIDEBAR_NAV_NODE: '.js-sidebar-nav-node',
    SIDEBAR_NAV_NODE_CHILDREN: '.js-sidebar-nav-node-children',
    SIDEBAR_NAV_NODE_CHILD_CONTAINER: '.js-sidebar-nav__node-child-container',
    SIDEBAR_NAV_NODE_PARENT_CONTAINER: '.js-sidebar-nav__node-parent-container',
    SIDEBAR_NAV_OVERLAY: '.js-sidebar-nav__overlay',
    SIGN_IN_BTN: '.js-sign-in-btn',
}


const AnalyticsEvents = {
    CLOSE_SIDEBAR: 'close sidebar',
    GET_APP_ANDROID: 'get the app | android',
    GET_APP_IOS: 'get the app | ios',
    JOIN_FOR_FREE: 'join for free',
    MOBILE_SIDEBAR_CLICKED: 'mobile sidebar clicked',
    MY_ACCOUNT: 'my account',
    MY_ORDERS: 'my orders',
    SIDEBAR: 'sidebar',
    SIGN_IN: 'sign in',
}


const Styles = {
    EXPANDED: 'expanded',
    HIDE: 'hide',
    ICON_ARROW_DOWN: 'icon-expand-arrow-down',
    ICON_ARROW_UP: 'icon-expand-arrow-up',
}


const ClassOverrides = {
    HIDE_IF_FANCLUB_MEMBER: 'js-hide-if-fanclub-member',
}


let sidebarElement


let currentBodyStyles
function preventBodyScroll(prevent) {
    if (prevent) {
        currentBodyStyles = {
            overflow: document.body.style.overflow,
            position: document.body.style.position,
            width: document.body.style.width,
            top: document.body.style.top,
            currentScrollPosition: window.pageYOffset || document.documentElement.scrollTop,
        };
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = `-${currentBodyStyles.currentScrollPosition}px`;
        document.body.style.width = '100%';
    }
    else {
        document.body.style.overflow = currentBodyStyles.overflow || '';
        document.body.style.position = currentBodyStyles.position || '';
        document.body.style.top = currentBodyStyles.top || '';
        document.body.style.width = currentBodyStyles.width || '';
        window.scrollTo(0, currentBodyStyles.currentScrollPosition);
    }
}
function openSidebar() {
    if (sidebarElement) {
        sidebarElement.classList.add(Styles.EXPANDED);
        preventBodyScroll(true);
        const contentWrapper = sidebarElement.querySelector(Selectors.SIDEBAR_NAV_CONTENT_WRAPPER);
        if (contentWrapper) {
            contentWrapper.scrollTop = 0;
        }
    }
}
function closeSidebar() {
    if (sidebarElement) {
        triggerAnalyticsEvent(AnalyticsEvents.CLOSE_SIDEBAR);
        sidebarElement.classList.remove(Styles.EXPANDED);
        preventBodyScroll(false);
    }
}
function setupClickHandlers() {
    const hamburgerMenu = document.querySelector(Selectors.HAMBURGER_MENU);
    hamburgerMenu?.addEventListener('click', openSidebar);
    const closeButton = document.querySelector(Selectors.CLOSE_BTN);
    closeButton?.addEventListener('click', closeSidebar);
    const overlay = document.querySelector(Selectors.SIDEBAR_NAV_OVERLAY);
    overlay?.addEventListener('click', closeSidebar);
    const joinBtn = document.querySelector(Selectors.JOIN_BTN);
    joinBtn?.addEventListener('click', () => {
        triggerAnalyticsEvent(AnalyticsEvents.JOIN_FOR_FREE);
        window.location = joinNow;
    });
    const signInBtn = document.querySelector(Selectors.SIGN_IN_BTN);
    signInBtn?.addEventListener('click', () => {
        triggerAnalyticsEvent(AnalyticsEvents.SIGN_IN);
        window.location = signIn;
    });
    const myOrdersLinkElement = document.querySelector(Selectors.SIDEBAR_NAV_MY_ORDERS);
    myOrdersLinkElement?.addEventListener('click', (e) => {
        e.preventDefault();
        triggerAnalyticsEvent(AnalyticsEvents.MY_ORDERS);
        window.location = myOrdersLinkElement.href;
    });
    const myAccountLinkElement = document.querySelector(Selectors.SIDEBAR_NAV_MY_ACCOUNT);
    myAccountLinkElement?.addEventListener('click', (e) => {
        e.preventDefault();
        triggerAnalyticsEvent(AnalyticsEvents.MY_ACCOUNT);
        window.location = myAccountLinkElement.href;
    });
    const iosAppDownloadElement = document.querySelector(Selectors.APP_DOWNLOAD_IOS);
    iosAppDownloadElement?.addEventListener('click', (e) => {
        e.preventDefault();
        triggerAnalyticsEvent(AnalyticsEvents.GET_APP_IOS);
        window.location = iosAppDownloadElement.href;
    });
    const androidAppDownloadElement = document.querySelector(Selectors.APP_DOWNLOAD_ANDROID);
    androidAppDownloadElement?.addEventListener('click', (e) => {
        e.preventDefault();
        triggerAnalyticsEvent(AnalyticsEvents.GET_APP_ANDROID);
        window.location = androidAppDownloadElement.href;
    });
}
function triggerAnalyticsEvent(navItem) {
    const event = {
        event: AnalyticsEvents.MOBILE_SIDEBAR_CLICKED,
        navItem,
    };
    window.dataLayer.push(event);
}
function setupDynamicContent() {
    const sidebarNavNodeElements = sidebarElement.querySelectorAll(Selectors.SIDEBAR_NAV_NODE);
    sidebarNavNodeElements.forEach((sidebarNavNodeElement) => {
        const returnEarly = classOverrideHandler(sidebarNavNodeElement);
        if (returnEarly) {
            return;
        }
        const parentText = sidebarNavNodeElement.getAttribute('data-label').toLowerCase();
        const linkElement = sidebarNavNodeElement.querySelector(Selectors.SIDEBAR_NAV_LINK);
        if (linkElement) {
            linkElement.addEventListener('click', (e) => {
                e.preventDefault();
                triggerAnalyticsEvent(parentText);
                window.location = linkElement.href;
            });
        }
        const expandIconElement = sidebarNavNodeElement.querySelector(Selectors.SIDEBAR_EXPAND_ICON);
        if (expandIconElement) {
            const childNodeContainerElement = sidebarNavNodeElement.querySelector(Selectors.SIDEBAR_NAV_NODE_CHILDREN);
            const childElements = childNodeContainerElement.querySelectorAll(Selectors.SIDEBAR_NAV_NODE_CHILD_CONTAINER);
            const hideAllChildren = Array.from(childElements).every(childElement => classOverrideHandler(childElement));
            if (hideAllChildren) {
                expandIconElement.classList.add(Styles.HIDE);
                return;
            }
            const isLink = Boolean(sidebarNavNodeElement.querySelector(Selectors.SIDEBAR_NAV_LINK));
            const targetElement = isLink
                ? expandIconElement
                : sidebarNavNodeElement.querySelector(Selectors.SIDEBAR_NAV_NODE_PARENT_CONTAINER);
            targetElement.addEventListener('click', () => {
                const isExpanding = childNodeContainerElement.classList.contains(Styles.EXPANDED);
                const navItem = `${parentText} | ${isExpanding ? 'close' : 'open'}`;
                triggerAnalyticsEvent(navItem);
                expandIconElement.classList.toggle(Styles.ICON_ARROW_DOWN);
                expandIconElement.classList.toggle(Styles.ICON_ARROW_UP);
                childNodeContainerElement.classList.toggle(Styles.EXPANDED);
            });
            childElements.forEach((childElement) => {
                const childLinkElement = childElement.querySelector(Selectors.SIDEBAR_NAV_CHILD_LINK);
                if (childLinkElement) {
                    childLinkElement.addEventListener('click', (e) => {
                        e.preventDefault();
                        const navItem = `${parentText} | ${childElement.getAttribute('data-label').toLowerCase()}`;
                        triggerAnalyticsEvent(navItem);
                        window.location = childLinkElement.href;
                    });
                }
            });
        }
    });
}
function classOverrideHandler(sidebarNavNodeElement) {
    return false;
}
function init() {
    sidebarElement = document.querySelector(Selectors.SIDEBAR_NAV);
    setupDynamicContent();
    setupClickHandlers();
}
module.exports = {
    init
};
export default module.exports;